import { authApi, defaultApi, createParams } from './index';

export const authenticate = async (request) => {
	try {
		const params = createParams(request);

		const { data } = await defaultApi.post(
			'/authenticate',
			{},
			{
				'Content-Type': 'application/x-www-form-urlencoded',
				params,
			},
		);

		console.log('authenticate result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const getMemberProfiles = async () => {
	try {
		const { data } = await authApi.get('/portal/member/profiles');
		console.log('memberProfiles', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const getMemberCollection = async () => {
	try {
		const { data } = await authApi.get('/portal/collection/member');

		console.log('getMemberCollection result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const findMemberByEmail = async (email) => {
	try {
		const { data } = await authApi.get(`/torooc/member/exists?email=${email}`);

		console.log('findMemberByEmail result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const setMember = async (request) => {
	try {
		const { data } = await authApi.post('/torooc/join/member/allRoles', {
			...request,
		});

		console.log('setMember result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const setCollection = async (request) => {
	try {
		const { data } = await authApi.post('/admin/recognition/collection', {
			...request,
		});

		console.log('setCollection result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const setProfile = async (request) => {
	try {
		const { data } = await authApi.post('/portal/member/profile', {
			...request,
		});

		console.log('setProfile result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const setCollectionProfile = async (request) => {
	try {
		const { data } = await authApi.post('/portal/collection/profiles', {
			...request,
		});

		console.log('setCollectionProfile result', data);
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const addProfile = async (request) => {
	if (!request.name) return null;
	if (request.file) {
		try {
			const url = `/portal/member/profiles/image?name=${request.name}`;
			const formData = new FormData();
			formData.append('file', request.file);
			const { data } = await authApi.post(url, formData);
			return data;
		} catch (error) {
			console.error(error);
			return null;
		}
	} else {
		try {
			const url = '/portal/member/profiles';
			const body = {
				name: request.name,
			};
			const { data } = await authApi.post(url, body);
			return data;
		} catch (error) {
			console.error(error);
			return null;
		}
	}
};

export const deleteProfile = async (request) => {
	try {
		const url = '/portal/member/profiles';
		const body = {
			name: request.name,
		};
		const { data } = await authApi.delete(url, body);
		return data;
	} catch (error) {
		console.error(error);
		return null;
	}
};
